import { Config } from "~/config";
import { MsalAuthenticationContext, 
        CypressAuthenticationContext,
        IAuthContextConfig,
        IAuthenticationContext,
        AuthenticationContextInIFrame
    } from "~/ad-authentication";

let authContext: IAuthenticationContext | undefined;

export const AuthContextFactory = {
    getAuthContext: (aadAuthConfig: IAuthContextConfig, insideIFrame: boolean): IAuthenticationContext => {
        if (!authContext) {
            if (insideIFrame) {
                authContext = new AuthenticationContextInIFrame(aadAuthConfig);
            } else {
                authContext = AuthContextFactory.getMSALAuthContext(aadAuthConfig);
            }
        }

        return authContext;
    },
    getMSALAuthContext: (aadAuthConfig: IAuthContextConfig): IAuthenticationContext => {
        const userLocalAccountId = localStorage.getItem("auth.localaccountid") ?? ""
        const isCypressTestingEnabled = localStorage.getItem("isCypressTestingEnabled") === "true" 
        const  useCypressAuthContext = Config.isDevEnvironment && isCypressTestingEnabled && Config.IsUserAllowedForCypressTesting(userLocalAccountId) 

        authContext = useCypressAuthContext 
            ? new CypressAuthenticationContext()
            : new MsalAuthenticationContext(aadAuthConfig)

        return authContext
    }
}
